/**
 * FilterTrigger
 * 
 * @Author: Focci
 * @Date: 2023-09-30 07:05:08
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-30 07:05:08
 */

import PropTypes from 'prop-types'
import { ButtonBase } from '@comp/material'
import FilterDropdownTrigger from '../../FilterDropdownTrigger'

export default function FilterTrigger({ onClick, disabled, ...props }) {
  return (
    <ButtonBase className="rounded-full" disabled={disabled} onClick={onClick}>
      <FilterDropdownTrigger
        className="!rounded-full transition-colors"
        activedClassName="border-primary text-primary bg-primary/10"
        unActivedClassName="hover:bg-[#f3f1f2] hover:border-c6c"
        {...props}
      />
    </ButtonBase>
  )
}

FilterTrigger.propTypes = {
  onClick: PropTypes.func,
}
